import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Box,
  VStack,
  Button,
  SimpleGrid,
  Stack,
  Text,
  Card,
  CardBody,
  Flex,
  Input,
  CardFooter,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Badge,
  Divider,
} from "@chakra-ui/react";
import { FaEdit, FaRupeeSign, FaTrash } from "react-icons/fa";
import { set } from "lodash";
import toast from "react-hot-toast";
import Cookie from "js-cookie";
import FoodUpdateModal from "./updateFoodModal";
//import Cookie from 'js-cookie';

const FoodData = () => {
  const token = Cookie.get("token");
  const [data, setData] = useState([]);
  // const token = Cookie.get('token');
  const [page, setPage] = useState(1); // Track the current page
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [food, setFood] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [typeFilter, setTypeFilter] = useState("All");
  const [nameFilter, setNameFilter] = useState("All");
  const [uniqueNames, setUniqueNames] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [isOpen1, setIsOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();

  const customerId = localStorage.getItem("customerId");
  console.log(customerId);
  const cacheImageUrl = (key, url) => {
    localStorage.setItem(`imageUrl-${key}`, url);
  };

  const getCachedImageUrl = (key) => {
    return localStorage.getItem(`imageUrl-${key}`);
  };

  // const fetchData = async () => {
  //   const response = await axios.get(`https://api.rasoi.launchlysoftware.in/api/getFoodData/${customerId}`);
  //   const rooms = response.data.food;
  //   const updatedRooms = await Promise.all(
  //     rooms.map(async (room) => {
  //       let cachedUrl = getCachedImageUrl(room.image);

  //       if (!cachedUrl) {
  //         const imageResponse = await axios.get('https://api.rasoi.launchlysoftware.in/image', {
  //           params: { customerId, key: room.image }
  //         });
  //         cachedUrl = imageResponse.data;
  //         cacheImageUrl(room.image, cachedUrl); // Cache the URL
  //       }

  //       room.imageUrl = cachedUrl;
  //       return room;
  //     })
  //   );
  //   console.log(updatedRooms, 'updatedRooms');
  //   setData(updatedRooms);
  //   setFilteredData(updatedRooms);
  //   setUniqueNames(['All', ...new Set(updatedRooms.map(item => item.category))]);

  // }
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getFoodData/${customerId}`,
      );
      const rooms = response.data.food;

      // Map over rooms and fetch images dynamically with caching
      // const updatedRooms = await Promise.all(
      //   rooms.map(async (room) => {
      //     if (room.image) {
      //       // Check if the image is already cached

      //         try {
      //           const imageResponse = await axios.get(`https://api.rasoi.launchlysoftware.in/get-image/${room.image}`, {
      //             responseType: 'blob', // Assuming the image is returned as a blob
      //           });

      //           // Create a blob URL for the image
      //           //cachedUrl = URL.createObjectURL(imageResponse.data);

      //           // Cache the URL for future use
      //           room.imageUrl=URL.createObjectURL(imageResponse.data)

      //         } catch (error) {
      //           console.error(`Error fetching image for room: ${room.image}`, error);
      //           room.imageUrl = null; // Fallback in case of error
      //         }

      //        // Assign the cached or fetched URL
      //     } else {
      //       room.imageUrl = null; // Handle cases where image is missing
      //     }
      //     return room;
      //   })
      // );

      // console.log(updatedRooms, 'updatedRooms');

      // Update the state with fetched data
      setData(rooms);
      setFilteredData(rooms);

      // Generate unique categories, adding "All" at the start
      setUniqueNames(["All", ...new Set(rooms.map((item) => item.category))]);
    } catch (error) {
      console.error("Error fetching food data:", error);
    }
  };

  const DeleteModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  const handleTypeFilterChange = (filter) => {
    setTypeFilter(filter);
    filterData(filter, nameFilter, searchQuery);
  };

  const handleNameFilterChange = (filter) => {
    setNameFilter(filter);
    filterData(typeFilter, filter, searchQuery);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterData(typeFilter, nameFilter, query); // Trigger filtering with the search input
  };
  const { onOpen, isOpen, onClose } = useDisclosure();

  const filterData = (type, name, search) => {
    let filtered = data;

    if (type !== "All") {
      filtered = filtered.filter((item) => item.type === type);
    }

    if (name !== "All") {
      filtered = filtered.filter((item) => item.category === name);
    }

    // Filter by search query (checks both name and code)
    if (search) {
      const lowerCaseSearch = search.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.name.toLowerCase().includes(lowerCaseSearch) ||
          item.code.toLowerCase().includes(lowerCaseSearch),
      );
    }

    setFilteredData(filtered);
  };
  const updateFood = async (id) => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getFoodDataById/${customerId}/${id}`,
      );
      console.log(response.data);
      setFood(response.data.food);
      setSelectId(id);
      onOpen();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/deleteFoodData/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      toast.success("Data deleted successfully");
      onClose1();
      fetchData();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [customerId]);

  return (
    <Flex h="calc(100vh - 80px)" overflow="hidden">
      {/* Sidebar */}
      <Box
        w="300px"
        bg="gray.50"
        borderRight="1px"
        borderColor="gray.200"
        overflowY="auto"
        p={5}
      >
        <VStack spacing={5} align="stretch">
          {/* Search Input */}
          <Box>
            <Text fontSize="md" fontWeight="700" mb={3} color="gray.800">
              Search
            </Text>
            <Input
              placeholder="Name or Code"
              value={searchQuery}
              onChange={handleSearchChange}
              size="md"
              bg="white"
              fontSize="sm"
              _focus={{
                borderColor: "green.400",
                boxShadow: "0 0 0 1px #48bb78",
              }}
            />
          </Box>

          <Divider borderColor="gray.300" />

          {/* Type Filter */}
          <Box>
            <Text fontSize="md" fontWeight="700" mb={3} color="gray.800">
              Type
            </Text>
            <VStack spacing={2.5} align="stretch">
              <Button
                size="md"
                onClick={() => handleTypeFilterChange("All")}
                colorScheme={typeFilter === "All" ? "green" : "gray"}
                variant={typeFilter === "All" ? "solid" : "outline"}
                justifyContent="flex-start"
                fontSize="sm"
                fontWeight="500"
                h="40px"
                _hover={{
                  transform: "translateX(4px)",
                  transition: "all 0.2s",
                }}
              >
                All
              </Button>
              <Button
                size="md"
                onClick={() => handleTypeFilterChange("Veg")}
                colorScheme={typeFilter === "Veg" ? "green" : "gray"}
                variant={typeFilter === "Veg" ? "solid" : "outline"}
                justifyContent="flex-start"
                fontSize="sm"
                fontWeight="500"
                h="40px"
                _hover={{
                  transform: "translateX(4px)",
                  transition: "all 0.2s",
                }}
              >
                Veg
              </Button>
              <Button
                size="md"
                onClick={() => handleTypeFilterChange("Non-Veg")}
                colorScheme={typeFilter === "Non-Veg" ? "green" : "gray"}
                variant={typeFilter === "Non-Veg" ? "solid" : "outline"}
                justifyContent="flex-start"
                fontSize="sm"
                fontWeight="500"
                h="40px"
                _hover={{
                  transform: "translateX(4px)",
                  transition: "all 0.2s",
                }}
              >
                Non-Veg
              </Button>
            </VStack>
          </Box>

          <Divider borderColor="gray.300" />

          {/* Category Filter */}
          <Box pb={2}>
            <Text fontSize="md" fontWeight="700" mb={3} color="gray.800">
              Category
            </Text>
            <VStack
              spacing={2.5}
              align="stretch"
              maxH="calc(100vh - 450px)"
              overflowY="auto"
              pr={2}
              css={{
                "&::-webkit-scrollbar": { width: "8px" },
                "&::-webkit-scrollbar-track": {
                  background: "#f7fafc",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#cbd5e0",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb:hover": { background: "#a0aec0" },
              }}
            >
              {uniqueNames.map((name, index) => (
                <Button
                  key={index}
                  size="md"
                  onClick={() => handleNameFilterChange(name)}
                  colorScheme={nameFilter === name ? "green" : "gray"}
                  variant={nameFilter === name ? "solid" : "outline"}
                  justifyContent="flex-start"
                  fontSize="14px"
                  fontWeight="500"
                  h="44px"
                  py={3}
                  _hover={{
                    transform: "translateX(4px)",
                    transition: "all 0.2s",
                  }}
                >
                  {name}
                </Button>
              ))}
            </VStack>
          </Box>
        </VStack>
      </Box>

      {/* Main Content */}
      <Box flex="1" overflowY="auto" p={6} bg="white">
        <FoodUpdateModal
          onClose={onClose}
          isOpen={isOpen}
          customerId={customerId}
          onOpen={onOpen}
          unique={uniqueNames}
          setSelectId={setSelectId}
          id={selectId}
          data={food}
        />

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing={4}>
          {filteredData.map((item, index) => (
            <Card
              key={index}
              boxShadow="md"
              borderRadius="lg"
              border="1px"
              borderColor="gray.200"
              _hover={{
                boxShadow: "lg",
                transform: "translateY(-2px)",
                transition: "all 0.2s",
              }}
            >
              <CardBody p={4}>
                <Flex justify="space-between" align="center" mb={3}>
                  <Badge
                    colorScheme={item.type === "Veg" ? "green" : "red"}
                    fontSize="xs"
                    px={2}
                    py={1}
                    borderRadius="md"
                  >
                    {item.type}
                  </Badge>
                  <Text fontSize="xs" color="gray.500" fontWeight="500">
                    {item.code}
                  </Text>
                </Flex>

                <VStack align="stretch" spacing={2}>
                  <Text
                    fontSize="md"
                    fontWeight="600"
                    color="gray.800"
                    noOfLines={2}
                  >
                    {item.name}
                  </Text>

                  <Text fontSize="xs" color="gray.600">
                    {item.category}
                  </Text>

                  <Divider />

                  <Flex justify="space-between" align="center">
                    <Text fontSize="sm" color="gray.600">
                      AC Rate:
                    </Text>
                    <Flex
                      align="center"
                      color="green.600"
                      fontWeight="600"
                      fontSize="sm"
                    >
                      <FaRupeeSign size={12} />
                      <Text ml={1}>{item.acRate}</Text>
                    </Flex>
                  </Flex>

                  {item.nonAcRate > 0 && (
                    <Flex justify="space-between" align="center">
                      <Text fontSize="sm" color="gray.600">
                        Non-AC Rate:
                      </Text>
                      <Flex
                        align="center"
                        color="green.600"
                        fontWeight="600"
                        fontSize="sm"
                      >
                        <FaRupeeSign size={12} />
                        <Text ml={1}>{item.nonAcRate}</Text>
                      </Flex>
                    </Flex>
                  )}
                </VStack>
              </CardBody>

              <CardFooter pt={0} pb={3} px={4}>
                <Flex gap={2} w="100%">
                  <Button
                    size="sm"
                    colorScheme="blue"
                    leftIcon={<FaEdit />}
                    onClick={() => updateFood(item._id)}
                    flex={1}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="red"
                    leftIcon={<FaTrash />}
                    onClick={() => DeleteModal(item._id)}
                    flex={1}
                  >
                    Delete
                  </Button>
                </Flex>
              </CardFooter>
            </Card>
          ))}
        </SimpleGrid>

        {filteredData.length === 0 && (
          <Flex justify="center" align="center" h="200px">
            <Text color="gray.500" fontSize="lg">
              No items found
            </Text>
          </Flex>
        )}
      </Box>

      {/* Delete Confirmation Dialog */}
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
};

export default FoodData;
